import { ipAddress, minValue, maxValue, numeric, required } from 'vuelidate/lib/validators'

const regexCodigo = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return (
    /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]).){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$|^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]).)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/.test(value)
  )
}


export const validateData = {
  form: {
    bindIP: { ipAddress, required },
    bindPort: { numeric, required, minValue: minValue(5000), maxValue: maxValue(65535) },
    externalIP: { regexCodigo },
  },
}

export const validateComputed = {
  bindIPErrors() {
    const errors = []
    if (!this.$v.form.bindIP.$dirty) return errors
    !this.$v.form.bindIP.required && errors.push('Campo obrigatório.')
    !this.$v.form.bindIP.ipAddress && errors.push('IP inválido.')
    return errors
  },
  bindPortErrors() {
    const errors = []
    if (!this.$v.form.bindPort.$dirty) return errors
    !this.$v.form.bindPort.required && errors.push('Campo obrigatório.')
    !this.$v.form.bindPort.numeric && errors.push('Insira um valor numérico.')
    !this.$v.form.bindPort.minValue && errors.push('Valor mínimo: 5000.')
    !this.$v.form.bindPort.maxValue && errors.push('Valor máximo: 65535.')
    return errors
  },
  externalIPErrors() {
    const errors = []
    if (!this.$v.form.externalIP.$dirty) return errors
    !this.$v.form.externalIP.regexCodigo && errors.push('IP inválido ou DNS Válido.')
    return errors
  },
}
